import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import "../../../StyleSheet/MainComponent/Management/Verifystatus.scss";
import offerLetter from "../../../Assets/MainComponent/OfferLetterImage/OfferLetter.png";
import offerLetter1 from "../../../Assets/AppComponent/OfferImg/OfferLetter.png";
import Sign from "../../../Assets/MainComponent/OfferLetterImage/Sign.svg";
import offerLetter2 from "../../../Assets/AppComponent/OfferImg/OfferLetters.png";
import { NavLink } from "react-router-dom";
import {
  getSideBarfilesActions,
  SetTheJoiningDateCall,
} from "../../../Redux/Slice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";

const VerifyStatus = () => {
  const Swal = require("sweetalert2");
  const [UserName, setUserName] = useState("");
  const [RoleName, setRoleNames] = useState();
  const [DateError, setDateError] = useState("");
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const navigate = useNavigate();

  ///---max and min the date selcted filed ,

  // let currentDate = new Date();
  // let year = currentDate.getFullYear();

  // // Calculate the end of the current year
  // let endOfYear = new Date(year, 11, 31); // December is 11th month (zero-based index)

  // // Format the current date and end of year
  // let currentMonth =
  //   (currentDate.getMonth() + 1 < 10 ? "0" : "") + (currentDate.getMonth() + 1);
  // let currentDay =
  //   (currentDate.getDate() < 10 ? "0" : "") + currentDate.getDate();
  // let formattedDate = `${year}-${currentMonth}-${currentDay}`;

  // let endOfYearMonth =
  //   (endOfYear.getMonth() + 1 < 10 ? "0" : "") + (endOfYear.getMonth() + 1);
  // let endOfYearDay =
  //   (endOfYear.getDate() < 10 ? "0" : "") + endOfYear.getDate();
  // let formattedEndOfYear = `${year}-12-31`;

  // console.log(`Current Date: ${formattedDate}`);
  // console.log(`End of Year: ${formattedEndOfYear}`);

  let currentDate = new Date();
  let year = currentDate.getFullYear();

  let endOfYear = new Date(year, 11, 31);
  let maxDate = new Date();
  maxDate.setDate(currentDate.getDate() + 60);

  let minDate = new Date();
  minDate.setDate(currentDate.getDate() - 15);

  // Format the date to YYYY-MM-DD
  function formatDate(date) {
    let month = (date.getMonth() + 1).toString().padStart(2, "0"); // getMonth() is zero-based
    let day = date.getDate().toString().padStart(2, "0");
    return `${date.getFullYear()}-${month}-${day}`;
  }

  let formattedCurrentDate = formatDate(currentDate);
  let formattedEndOfYear = formatDate(endOfYear);
  let formattedMaxDate = formatDate(maxDate);
  let formattedMinDate = formatDate(minDate);

  console.log(`Current Date: ${formattedCurrentDate}`);
  console.log(`End of Year: ${formattedEndOfYear}`);
  console.log(`Max Date (60 days from now): ${formattedMaxDate}`);
  console.log(`Min Date (15 days before today): ${formattedMinDate}`);

  const state = useSelector((state) => state);
  const initialState = {
    date: state.NeededdatasListed.dateOfJoing,
  };

  console.log(state.NeededdatasListed.dateOfJoing, "dateOfJoing");
  const [data, setData] = useState(initialState);
  const dispatch = useDispatch();
  useEffect(() => {
    if (state.EmployeeProfile.EmployeeProfileList.id != undefined) {
      setUserName(
        state.EmployeeProfile.EmployeeProfileList.user_id.first_name.toUpperCase()
      );
      setRoleNames(
        state.EmployeeProfile.EmployeeProfileList.user_id.user_role.role
      );
      //  console.log( state.EmployeeProfile.EmployeeProfileList.user_id.id ,"UserIds");
    }
  }, []);

  const HandleChanges = (e) => {
    setData({
      ...data,
      date: e.target.value,
    });
    setDateError("");
  };
  // console.log(data, "data");
  const handleGenerat = (e) => {
    var a = 0;
    if (data.date == "") {
      a = 1;
      setDateError("*Date is required");
    }
    if (a == 0) {
      Swal.fire({
        title: "Are you sure, do you want Generate ?",
        text: "You won't be able to revert this",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f26639",
        cancelButtonColor: "#F69338",
        confirmButtonText: "Yes, Generate it!",
      }).then((result) => {
        if (result.isConfirmed) {
          // Swal.fire(
          //   "Deleted!",
          //   "Given Info has been deleted.",
          //   "success"
          // );

          const Form_data = new FormData();
          Form_data.append("joining_date", data.date != "" ? data.date : null);
          // const joiningDate = "2022-01-02";
          //const jsonDate = { joining_date: data.date };
          // const jsonDate = JSON.stringify({ joining_date: data.date.toISOString() });
          //  Form_data.append("asd","asdasd")
          //console.log(jsonDate, "iioioiokl" , jsonDate);
          const jsonData = {
            joining_date: `${data.date != "" ? data.date : null}`,
          };
          const payload = {
            Form_data: Form_data,
            date: data.date,
            jsonData: jsonData,
            Ids: state.EmployeeProfile.EmployeeProfileList.user_id.id,
          };
          dispatch(SetTheJoiningDateCall(payload));

          // Swal.fire({
          // text: "Employee file has been moved",
          // icon: "success",
          // });

          // setData({
          // ...data ,
          // date:""
          // })
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire({
            text: "This Employee is rejected",
            icon: "error",
          });
          Swal.close();
          setData({
            ...data,
            date: "  ",
          });
        }
      });
    }
  };

  const HandleSubmits = (e) => {
    e.preventDefault();
  };
  return (
    <>
      <div className="Verify">
        <div className={stateDisplay ? "outterContent" : "inner-Content"}>
          <div className="Header-Details ClientBranch row">
            <div
              class="col-sm-7 auto"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                paddingLeft: "0px ",
                paddingRight: "0px",
              }}
            >
              <h3>Employee Offer Letter </h3>
              <ul class="breadcrumb">
                {state.ClientBranchIDs.DashboardIDs != 1 ? (
                  // <li class="breadcrumb-item">
                  //   <NavLink
                  //     style={{ textDecoration: "none", color: "#333333" }}
                  //     to={"/verifyrequest"}
                  //     onClick={(e) => {
                  //       dispatch(
                  //         getSideBarfilesActions("Verification Request")
                  //       );
                  //     }}
                  //   >
                  //     Verification Request
                  //   </NavLink>
                  // </li>
                  <li class="breadcrumb-item">
                    <NavLink
                      style={{ textDecoration: "none", color: "#333333" }}
                      // to={"/"}
                      to={
                        state.SideBarFiles.SideBarFile == "Overview"
                          ? "/"
                          : "/onboardDashboard"
                      }
                      onClick={(e) => {
                        dispatch(
                          getSideBarfilesActions(state.SideBarFiles.SideBarFile)
                        );
                      }}
                    >
                      {state.SideBarFiles.SideBarFile}
                    </NavLink>
                  </li>
                ) : null}

                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/employeeVerifylist"}
                    onClick={(e) => {
                      // dispatch(getSideBarfilesActions("Employee Verification"));
                      dispatch(getSideBarfilesActions("Approve Request"));
                    }}
                  >
                    Employee list
                  </NavLink>
                </li>
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/employeeprofile"}
                    onClick={(e) => {
                      // dispatch(getSideBarfilesActions("Employee Verification"));
                      dispatch(getSideBarfilesActions("Approve Request"));
                    }}
                  >
                    Employee Profile
                  </NavLink>
                </li>
                <li class="breadcrumb-item active"> Employee Offer Letter </li>
              </ul>
            </div>
          </div>

          <div
            className="row Filters ButtonPrevious"
            style={{
              padding: "15px 28px",
              margin: "0px",
              position: "relative",
              zIndex: "30",
                 
              marginLeft: "0px",
              marginRight: "0px",
              top: "-30px",
            }}
          >
            <div className="col">
              {state.ClientBranchIDs.DashboardIDs != 1 ? (
                <button
                  className="btn BackImga"
                  onClick={(e) => {
                    navigate(
                      state.SideBarFiles.SideBarFile == "Overview"
                        ? "/"
                        : "/onboardDashboard"
                    );
                  }}
                >
                  <i class="fa-solid fa-chevron-left"></i>
                  <span></span>
                </button>
              ) : (
                <button
                  className="btn"
                  onClick={(e) => {
                    navigate("/employeeprofile");
                  }}
                >
                  <img  className="PreviousPages" src={BackImage}/>
                  <span></span>
                </button>
              )}
            </div>
          </div>

          <div className="Header-Details">
            <div className="InnerDetails">
              <div className="InnerDetailPart">
                <div className="LOGO">
                  <img src={profile2} />
                </div>
                <p>{UserName}</p>
              </div>
              <div className="ROLE">
                <div className="LOGO">
                  <h4>{RoleName}</h4>
                </div>
              </div>
            </div>
          </div>

          <div className="OfferLetters">
            <div className="row">
              <div className="col-12">
                <div>
                  <span>Offer Letter</span>
                </div>
              </div>
              <div className="col-12 LetterPart">
                <div className="OfferLetterImage">
                  {state.SignatureCallSignature}
                  <a href={offerLetter2} target="blank">
                    <img src={offerLetter2} width="100%" height="100%" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className=" OfferLettersGenerators row">
            <div className=" Aproval-Generator">
              <div className="Approval">
                <div className="Heading">Approval Signature</div>
                <div className="approved-Signed">
                  <div className="SignImage">
                    <img src={Sign} width="100%" height="100%" />
                  </div>
                </div>
              </div>
            </div>
            <form onSubmit={HandleSubmits}>
              <div className="  JoiningdateField">
                <label class="form-label">Joining Date</label>
                <input
                  type="date"
                  class="form-control Joining_dates"
                  id="validationCustom01"
                  name="date"
                  autocomplete="off"
                  onChange={(e) => HandleChanges(e)}
                  // max={formattedEndOfYear}
                  // min={formattedDate}
                  max={formattedMaxDate}
                  min={formattedMinDate}
                  value={data.date}
                />
                <p className="Error">{DateError}</p>
              </div>

              <div className="Generator">
                <button
                  onClick={(e) => handleGenerat(e)}
                  type="submit"
                  className="ButtonCSS"
                >
                  Generate
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyStatus;
